import React from 'react'
import {Box, Button, Typography} from '@material-ui/core'
import styled from 'styled-components'
import colors from '../../shared/constants/colors'

const ErrorBox = styled(Box)`
  width: 100%;
  padding-bottom: 100;
`

const ParoTitle = styled(Box)`
  color: ${colors.paroBlack};
  padding: 0px 0px 18px 0px;
`

const ParoSubtitle = styled.div`
  color: ${colors.paroBlack};
  margin-bottom: 24px;
`

export default () => {
  return (
    <ErrorBox>
      <Box
        display="flex"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        padding="100px 0px 36px 5px;"
      >
          <Typography variant="h6" gutterBottom>
        <ParoTitle>Oops! We had a misstep.</ParoTitle>
          </Typography>
          <Typography variant="body1" gutterBottom>
              <ParoSubtitle>Retry or contact support if the issue persists</ParoSubtitle>
          </Typography>
        <Button
          variant="contained"
          color="inherit"
          size="small"
          style={{ width: 179, height: 34, borderRadius: 2 }}
          onClick={() => window.location.reload()}
        >
          Retry
        </Button>
      </Box>
    </ErrorBox>
  )
}
